import { createIcon } from '@chakra-ui/icons';

const CompassIcon = createIcon({
  path: (
    <>
      <path
        d='M10.0003 1.66699C5.40533 1.66699 1.66699 5.40533 1.66699 10.0003C1.66699 14.5953 5.40533 18.3337 10.0003 18.3337C14.5953 18.3337 18.3337 14.5953 18.3337 10.0003C18.3337 5.40533 14.5953 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32449 16.667 3.33366 13.6762 3.33366 10.0003C3.33366 6.32449 6.32449 3.33366 10.0003 3.33366C13.6762 3.33366 16.667 6.32449 16.667 10.0003C16.667 13.6762 13.6762 16.667 10.0003 16.667Z'
        fill='currentColor'
      />
      <path
        d='M6.66699 13.3337L11.6595 11.667L13.3337 6.66699L8.33366 8.33366L6.66699 13.3337Z'
        fill='currentColor'
      />
    </>
  ),
  viewBox: '0 0 20 20',
});

export default CompassIcon;
